import { render } from "./IconTrash.vue?vue&type=template&id=892058c4"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__